interface LoadingModalProps {
  label?: string;
}

function LoadingModal({ label = 'Loading...' }: LoadingModalProps) {
  return (
    <div className="pos-modal-portal">
      <div className="pos-modal-overlay">
        <div className="pos-loader pos-loader_type_light">
          <div className="pos-loader__spinner"></div>
          <p className="pos-loader__label">{label}</p>
        </div>
      </div>
    </div>
  );
}

export default LoadingModal;
